(function () {
	const isVisible = (element) => {
		if (!element) return false;

		const style = window.getComputedStyle(element);

		return (
			style.display !== "none" &&
			style.visibility !== "hidden" &&
			style.opacity !== "0" &&
			!!(element.offsetWidth || element.offsetHeight || element.getClientRects().length)
		);
	};

	const getHeaderOffset = () => {
		const rootStyles = window.getComputedStyle(document.documentElement);
		const cssHeaderHeight = parseFloat(rootStyles.getPropertyValue("--header-height")) || 0;

		if (cssHeaderHeight) return cssHeaderHeight;

		const header = document.querySelector(".shopify-section-header");
		return header?.getBoundingClientRect().height || 0;
	};

	const getMainProductMediaWrapper = () => {
		const desktopSelector = ".product__media-wrapper.main-product-desktop-section-wrapper";
		const mobileSelector = ".product__media-wrapper.main-product-mobile-section-wrapper";

		const selectors =
			window.innerWidth < 750
				? [mobileSelector, desktopSelector, ".product__media-wrapper"]
				: [desktopSelector, mobileSelector, ".product__media-wrapper"];

		for (const selector of selectors) {
			const wrapper = Array.from(document.querySelectorAll(selector)).find(isVisible);

			if (wrapper) return wrapper;
		}

		return null;
	};

	const scrollToMainProductMediaWrapper = () => {
		const wrapper = getMainProductMediaWrapper();

		if (!wrapper) return;

		const headerOffset = getHeaderOffset();
		const wrapperTop = wrapper.getBoundingClientRect().top + window.pageYOffset;
		const scrollTop = Math.max(wrapperTop - headerOffset - 8, 0);

		window.scrollTo({
			top: scrollTop,
			behavior: "smooth",
		});
	};

	window.scrollToMainProductMediaWrapper = scrollToMainProductMediaWrapper;

	const initProductAccordion = () => {
		if (typeof $ === "undefined") return;

		$(".about__accordion-toggle")
			.off("click.productAccordion")
			.on("click.productAccordion", function () {
				if (!$(this).hasClass("active")) {
					$(this).addClass("active");
					$(this)
						.siblings(".about__accordion-description")
						.eq($(this).index())
						.stop()
						.slideDown(300);
				} else {
					$(this).removeClass("active");
					$(this).siblings(".about__accordion-description").stop().slideUp(300);
				}
			});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(".product-media-modal__content");

		if (!imagesWrapper) return;

		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			if (el.dataset.zoomInit === "true") return;

			el.dataset.zoomInit = "true";

			el.addEventListener("click", () => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const handleRevealPopup = () => {
		const stickyBar = document.querySelector(".product__popup");
		const secondSection = document.querySelector(".product-section + section");
		const footer = document.querySelector("footer");

		if (!stickyBar || !secondSection || !footer) {
			if (stickyBar) stickyBar.classList.remove("active");
			return;
		}

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const secondSectionTop = getOffset(secondSection);
		const footerTop = getOffset(footer);
		const scrollBottom = window.scrollY + window.innerHeight;

		const shouldShowPopup = window.scrollY > secondSectionTop && scrollBottom < footerTop;

		stickyBar.classList[shouldShowPopup ? "add" : "remove"]("active");
	};

	const initRevealPopup = () => {
		if (window.__productRevealPopupHandler) {
			document.removeEventListener("scroll", window.__productRevealPopupHandler);
		}

		let ticking = false;

		window.__productRevealPopupHandler = () => {
			if (ticking) return;

			ticking = true;

			window.requestAnimationFrame(() => {
				handleRevealPopup();
				ticking = false;
			});
		};

		document.addEventListener("scroll", window.__productRevealPopupHandler, {
			passive: true,
		});

		handleRevealPopup();
	};

	const initProductScripts = () => {
		initProductAccordion();
		initZoomImage();
		initRevealPopup();
	};

	document.addEventListener("shopify:section:load", initProductScripts);

	initProductScripts();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, "text/html");

				this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');

				if (!this.productElement) return;

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) {
					window.ProductModel.loadShopifyXR();
				}

				this.showMoreFields();
			})
			.catch((error) => {
				console.error("Floated product form failed to load:", error);
			})
			.finally(() => {
				this.initDropdowns();
				this.bindPopupVariantScroll();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");

			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});

			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		if (!this.productElement) return;

		const sectionId = this.productElement.dataset.section;

		if (!sectionId) return;

		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		this.productElement.querySelectorAll("variant-selects").forEach((selects) => {
			selects.dataset.originalSection = sectionId;
		});

		this.productElement.querySelectorAll("variant-radios").forEach((radios) => {
			radios.dataset.originalSection = sectionId;
		});
	}

	removeDOMElements() {
		if (!this.productElement) return;

		const removableSelectors = [
			".product__text",
			".product__tags",
			".product__title__wrapper",
			".product__custom-badges",
			".price-wrapper",
			".product__description",
			".product__sku",
			".product__inventory",
			"pickup-availability",
			".custom-liquid",
			"product-recommendations",
			".share-buttons",
			"floated-form",
		];

		removableSelectors.forEach((selector) => {
			const elements = this.productElement.querySelectorAll(selector);

			elements.forEach((element) => {
				element.remove();
			});
		});

		const productModals = this.productElement.querySelectorAll(".product-popup");

		productModals.forEach((modal) => {
			modal.remove();
		});
	}

	initDropdowns() {
		if (typeof $ === "undefined") return;

		const $scope = $(this).closest(".product__popup").length
			? $(this).closest(".product__popup")
			: $(this);

		$scope.find(".product-form__controls--dropdown").each(function () {
			const $dropdown = $(this);
			const $listItems = $dropdown.find(".dropdown-select ul li");
			const $list = $dropdown.find(".dropdown-select ul");
			const $selectedText = $dropdown.find(".dropdown-select .select-label");

			$selectedText
				.off("click.floatedDropdown")
				.on("click.floatedDropdown", function (event) {
					event.stopPropagation();

					$scope.find(".dropdown-select ul").not($list).removeClass("active");
					$list.toggleClass("active");
				});

			$listItems
				.off("click.floatedDropdown")
				.on("click.floatedDropdown", function () {
					$selectedText
						.find("span")
						.text($(this).text())
						.attr("title", $(this).text());

					$list.removeClass("active");

					if (document.activeElement) {
						document.activeElement.blur();
					}
				});
		});

		$(document)
			.off("click.floatedDropdown")
			.on("click.floatedDropdown", function () {
				$(".product__popup .dropdown-select ul").removeClass("active");
			});
	}

	scheduleMainMediaScroll() {
		window.clearTimeout(this._scrollToMediaTimer);

		this._scrollToMediaTimer = window.setTimeout(() => {
			if (typeof window.scrollToMainProductMediaWrapper === "function") {
				window.scrollToMainProductMediaWrapper();
			}
		}, 350);
	}

	bindPopupVariantScroll() {
		if (this._popupVariantScrollBound) return;

		this._popupVariantScrollBound = true;

		this.addEventListener("change", (event) => {
			const variantTarget = event.target.closest(
				'variant-radios input[type="radio"], variant-selects select, .product-form__input input[type="radio"], .product-form__input select'
			);

			if (!variantTarget) return;

			this.scheduleMainMediaScroll();
		});

		this.addEventListener("click", (event) => {
			const variantTarget = event.target.closest(
				'variant-radios label, variant-radios input[type="radio"], variant-selects select, .product-form__controls--dropdown .dropdown-select ul li'
			);

			if (!variantTarget) return;

			this.scheduleMainMediaScroll();
		});
	}

	showMoreFields() {
		if (typeof $ === "undefined") return;

		$(".js-show-more")
			.off("click.showMoreFields")
			.on("click.showMoreFields", function (event) {
				event.preventDefault();

				$(this).siblings("input").removeClass("hidden");
				$(this).siblings("label").removeClass("hidden");
				$(this).remove();
			});
	}
}

if (!customElements.get("floated-form")) {
	customElements.define("floated-form", FloatedForm);
}